








































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { fieldOptionsArr, predicateOptions, predicateCn } from '@/config/map.conf';
import * as api from '@/api';
import ComponentCity from '@/views/rg/detail/components/customForm/form/Template/System/componentCity.vue';

/**
 * 触发器 触发条件
 *
 * @author liyuyao
 * @date 08/20/2019
 */
@Component({
    components: { ComponentCity }
})
export default class ConditionGroup extends Vue {
    @Prop()
    conditionGroup: CommonTypes.conditionGroupDo;

    @Prop({ default: 0 })
    groupIndex: number;

    @Prop({ default: 0 })
    submitSingle: number;

    @Prop({ default: false })
    showDeleteGroup: boolean;

    fieldOptionsArr: Array<{ value: any; label: string }> = fieldOptionsArr;
    predicateOptions: any = predicateOptions;
    predicateCn: any = predicateCn;
    orgDisplay: string[] = [];

    itemForm: any = {
        itemLogic: 'OR',
        parentId: 0,
        id: 0,
        conditions: [
            {
                fieldName: '',
                fieldPredicate: '',
                fieldValue: '',
                parentId: 0,
                id: 0,
                conditionItemStatus: true
            }
        ]
    };
    searchLoading: boolean = false;
    orgList: any = [];

    withErrorArr: boolean[] = [false];
    withInvalidArr: boolean[] = [false];

    @Watch('submitSingle')
    catchSubmitSingle() {
        if (!this.formError) {
            this.$emit('change', this.formatItemForm, this.groupIndex);
        }
    }
    @Watch('conditionGroup', { immediate: true, deep: true })
    onGetDetailCondition() {
        if (this.conditionGroup.conditions && this.conditionGroup.conditions.length) {
            this.itemForm = this.conditionGroup;
            this.itemForm.conditions.forEach((condition, index) => {
                if (condition.fieldName === 'ORG' && condition.fieldValue) {
                    this.getOrgDetail(condition.fieldValue, index);
                }
            });
        }
    }
    onConditionOrgChanged(index) {
        this.itemForm.conditions[index].conditionItemStatus = true;
    }
    deleteGroup() {
        this.$emit('delete', this.groupIndex);
    }
    addCondition() {
        if (this.itemForm.conditions.length < 50) {
            this.itemForm.conditions.push({
                fieldName: '',
                fieldPredicate: '',
                fieldValue: '',
                conditionItemStatus: true
            });
            this.withErrorArr.push(false);
        } else {
            this.$mtd.message.error('最多允许添加50个条件');
        }
    }
    deleteCondition(index) {
        this.itemForm.conditions.splice(index, 1);
        this.withErrorArr.splice(index, 1);
    }
    conditionChange(index) {
        this.itemForm.conditions[index].fieldPredicate = '';
        this.itemForm.conditions[index].fieldValue = '';
        this.itemForm.conditions[index].conditionItemStatus = true;
        this.itemForm.conditions[index].itemInvalidReason = '';
    }
    handleCityChange(city, index) {
        this.itemForm.conditions[index].fieldValue = city;
    }
    async searchOrg(query) {
        this.orgList = [];
        if (query.length < 2 || query === '集团') {
            return;
        }
        this.searchLoading = true;
        try {
            const res = await api.ruleApi.searchOrg(query);
            this.orgList = res.data.items;
        } catch (e) {
            this.orgList = [];
            console.log(e);
        }
        this.searchLoading = false;
    }
    async getOrgDetail(orgId, index) {
        if (!orgId) return;
        try {
            const res = await api.ruleApi.getOrgDetail(orgId);
            this.orgList.push(res.data);
            this.orgDisplay[index] = res.data.orgPath;
        } catch (e) {
            this.orgList = [];
            console.log(e);
        }
    }
    get formatItemForm() {
        const format: CommonTypes.conditionGroupDo = {
            itemLogic: this.itemForm.itemLogic,
            conditions: this.itemForm.conditions.map(condition => {
                const formatCondition: CommonTypes.conditionDO = {
                    fieldName: condition.fieldName,
                    fieldPredicate: condition.fieldPredicate,
                    fieldValue: condition.fieldValue,
                    conditionItemStatus: condition.conditionItemStatus,
                    itemInvalidReason: condition.itemInvalidReason
                };
                if (!!condition.id) {
                    formatCondition.id = condition.id;
                    formatCondition.parentId = condition.parentId;
                }
                return formatCondition;
            })
        };
        if (!!this.itemForm.id) {
            format.id = this.itemForm.id;
            format.parentId = this.itemForm.parentId;
        }
        return format;
    }
    get formError() {
        this.itemForm.conditions.forEach((condition, index) => {
            const validate = (condition.fieldName && condition.fieldPredicate && condition.fieldValue) || false;
            const statusValid = condition.conditionItemStatus;
            this.$set(this.withErrorArr, index, !validate);
            this.$set(this.withInvalidArr, index, !statusValid);
        });
        const hasArror = this.withErrorArr.includes(true);
        const hasInvalidArror = this.withInvalidArr.includes(true);
        // 在原有的校验逻辑上增加对invalid信息的校验
        this.$emit('error', hasArror || hasInvalidArror || false);
        return hasArror;
    }
}
